import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../Tooltip';
import GeoFilterDropdown from '../../../GeoFilterDropdown';
import SimpleCheckbox from '../../../Checkbox/SimpleCheckbox';

const decorateGeoButtonLabel = label => (label.includes('Multiple') ? 'Multiple' : label);

const RegionsCountries = ({
  active,
  regionsList,
  disabled = false,
  hideWWAggregation = false,
  enableWWAggregation = false,
  toggleWWAggregation,
  onChange,
}) => {
  const isWWSelected = active.includes('WW');

  return (
    <section className="export-settings-section">
      <div className="export-settings-section__about">
        <h4 className="h5 export-settings-section__title">
          Regions & Countries
        </h4>
        <p className="paragraph-md export-settings-section__description">Select the regions and countries you are interested in.</p>
      </div>
      <div className="export-settings-section__content">
        <div className="export-settings-section__options regions-options">
          <GeoFilterDropdown
            selected={active}
            regionsList={regionsList}
            decorateButtonLabel={decorateGeoButtonLabel}
            disabled={disabled}
            onChange={onChange}
          />
          {!hideWWAggregation && (
            <div className={cx('ww-aggregation-checkbox', { disabled: disabled || isWWSelected })}>
              <SimpleCheckbox
                id="aggregation-option-checkbox"
                label="Include Worldwide as additional region"
                checked={enableWWAggregation}
                disabled={disabled || isWWSelected}
                gap="8px"
                size="lg"
                className="checkbox-text-14"
                onChange={toggleWWAggregation}
              />
              <Tooltip content="Selecting this option will add an aggregation for WW to the output file">
                <i className="hicon-question-circle" />
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

RegionsCountries.propTypes = {
  active: T.array.isRequired,
  regionsList: T.array.isRequired,
  disabled: T.bool,
  hideWWAggregation: T.bool,
  enableWWAggregation: T.bool,
  toggleWWAggregation: T.func.isRequired,
  onChange: T.func.isRequired,
};

export default RegionsCountries;
